export default __webpack_public_path__ + "static/media/analytics.51050128.svg";